export default function PhotoPlaceholder({ label = "Photo du club à venir", className = "" }) {
  return (
    <div
      data-testid="photo-placeholder"
      className={`relative bg-navy2 overflow-hidden flex items-center justify-center ${className}`}
    >
      <div
        className="absolute inset-0 opacity-[0.15]"
        style={{ backgroundImage: "repeating-linear-gradient(115deg, transparent 0 22px, rgba(217,4,41,0.9) 22px 23px)" }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-navy/70 via-transparent to-navy/40" aria-hidden="true" />
      <div className="relative text-center px-8 py-12">
        <p className="font-heading font-semibold uppercase tracking-tighter text-outline-white leading-none text-5xl sm:text-7xl select-none">
          Le Boulou
        </p>
        <span className="mt-6 inline-block bg-rouge text-white text-[10px] font-bold uppercase tracking-[0.25em] px-3 py-1.5">
          {label}
        </span>
      </div>
    </div>
  );
}
